import React, { Fragment, useEffect, useState } from 'react';

import keyBy from 'lodash.keyby';

import {
  Listbox,
  Transition,
} from '@headlessui/react';
import { ChevronDownIcon } from 'lucide-react';
import { OptionProps } from './SbModel';


function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
  interface SelectListProps {
    id: string;
    options: OptionProps[];
    initialValue: OptionProps;
    onChange: (value: OptionProps) => void;
    disabled?: boolean;
    placeholder?: string;
  }
    
    const SelectList: React.FC<SelectListProps> = ({
      id,
      options,
      initialValue,
      onChange,
      disabled = false,
      placeholder = "Select an option"
    }) => {
    const [selectedOption, setSelectedOption] = useState <OptionProps>({ id: '', name : '' });

      
      useEffect(() => {
        console.log('options', options);
        setSelectedOption(initialValue);
      }, [initialValue]);
  return (
    <Listbox value={selectedOption} onChange={onChange}
      disabled={disabled}    >
      {({ open }) => (
        <>
          <div className="relative w-full ">
            <Listbox.Button className="flex items-start justify-between relative w-full cursor-pointer rounded-md bg-white py-1.5 px-3 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 text-sm sm:leading-6 focus:ring-2 focus:ring-inset focus:ring-blue-500">
              <div className="flex items-center gap-2">
                {/* <div
                  className="w-4 h-4 rounded-sm"
                  style={{  }}
                /> */}
                <span className="block truncate">{selectedOption?.name || ''}</span>
              </div>
              <ChevronDownIcon className="w-5 h-5" />
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {options.map((option) => (
                  <Listbox.Option
                    key={option.id}
                    className={({ active }) =>
                      classNames(
                        active ? 'bg-blue-200' : 'text-gray-700',
                        'relative cursor-pointer select-none py-2 pl-3 pr-9'
                      )
                    }
                    value={option}
                  >
                    {({ selected, active }) => (
                      <div className="flex gap-2 items-start">
                        {/* <div
                          className="w-4 h-4 rounded-sm"
                        /> */}
                        <span
                          className={classNames(
                            selected ? 'font-semibold' : 'font-normal',
                            'block truncate'
                          )}
                        >
                          {option.name}
                        </span>
                      </div>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
}
  export default SelectList;
